import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/logo/trust_fund_title.svg'


const _hoisted_1 = { class: "header-mobile-view mobile-only" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "login-btn logged-in pointer-hover" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "login-btn respect" }, " 님", -1)
const _hoisted_6 = { class: "header-brwr-view desktop-only" }
const _hoisted_7 = { class: "header-area" }
const _hoisted_8 = { class: "menu" }
const _hoisted_9 = { class: "login-btn logged-in pointer-hover" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "login-btn respect" }, " 님", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "title",
          class: "header-logo pointer-hover",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mobileLogout && _ctx.mobileLogout(...args)))
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.userName) + " ", 1),
          _hoisted_5
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "title",
            class: "header-logo pointer-hover",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mobileLogout && _ctx.mobileLogout(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.userName) + " ", 1),
          _hoisted_10
        ])
      ])
    ])
  ], 64))
}